import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import useResponsive from '~/hooks/useResponsive';

export default function ViewKeyLoading() {
  const { isMobile } = useResponsive();

  return (
    <Stack direction="column" spacing={1}>
      <Skeleton variant="text" width={250} />
      <Skeleton variant="text" width={120} />
      <Stack spacing={1} mt={2}>
        <Skeleton variant="text" width={isMobile() ? 250 : 550} height={360} />
      </Stack>
    </Stack>
  );
}
